import { useGetAllProvidersQuery } from '../api'

export const useGetAllProviders = () => {
  const { data } = useGetAllProvidersQuery()
  return { options: data ?? [] }
}
